(function () {
  function slugify(text) {
    var s = (text || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\u00c0-\u024f\u4e00-\u9fff-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return s || 'section';
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function resolveHashTarget(frag) {
    if (!frag) return null;
    var target = document.getElementById(frag);
    if (target) return target;
    try {
      target = document.getElementById(decodeURIComponent(frag.replace(/\+/g, ' ')));
    } catch (err) {}
    return target || null;
  }

  function replaceHashForId(id) {
    if (!id) return;
    try {
      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    } catch (err) {}
  }

  function scrollMarkerY() {
    var h = 0;
    try {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      if (raw) {
        var n = parseFloat(raw);
        if (!isNaN(n)) h = n;
      }
    } catch (e) {}
    if (!h) h = 72;
    return h + 28;
  }

  function ensureHeadingId(heading, usedIds, base, index) {
    var id = heading.id;
    if (!id) {
      id = slugify(heading.textContent || base) + '-' + (index + 1);
      var n = 0;
      var orig = id;
      while (usedIds[id] || document.getElementById(id)) {
        n += 1;
        id = orig + '-' + n;
      }
      heading.id = id;
    }
    usedIds[id] = true;
    return id;
  }

  function navigateArticleHash(main, rawFrag, options) {
    var opts = options || {};
    var target = resolveHashTarget(rawFrag);
    if (!target) return false;
    if (main && !main.contains(target)) return false;

    var motion =
      opts.behavior != null ? opts.behavior : prefersReducedMotion() ? 'auto' : 'smooth';

    target.scrollIntoView({ behavior: motion, block: 'start' });
    replaceHashForId(target.id);
    return true;
  }

  function findTocLinkByTargetId(listEl, id) {
    if (!id || !listEl) return null;
    var links = listEl.querySelectorAll('a[data-toc-target]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('data-toc-target') === id) {
        return links[i];
      }
    }
    return null;
  }

  function expandSectionForTarget(listEl, targetEl) {
    if (!listEl || !targetEl || !targetEl.id) return;
    var link = findTocLinkByTargetId(listEl, targetEl.id);
    if (!link) return;
    var section = link.closest('.article-sidebar__toc-section');
    if (!section) return;
    var btn = section.querySelector('.article-sidebar__toc-chevron');
    var sub = section.querySelector('.article-sidebar__toc-sublist');
    if (btn && sub) {
      btn.setAttribute('aria-expanded', 'true');
      sub.hidden = false;
    }
  }

  function scrollActiveTocItemIntoView(listEl, activeLink) {
    if (!listEl || !activeLink) return;
    var scroll = listEl.closest('.article-sidebar__toc-scroll');
    if (!scroll) return;
    var row =
      activeLink.classList.contains('article-sidebar__toc-link--child')
        ? activeLink.closest('li')
        : activeLink.closest('.article-sidebar__toc-section-head');
    if (!row) return;
    try {
      row.scrollIntoView({
        block: 'nearest',
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    } catch (e) {
      row.scrollIntoView(false);
    }
  }

  function setActiveTocLink(listEl, activeId) {
    if (!listEl) return;
    listEl.querySelectorAll('.article-sidebar__toc-section-head--current').forEach(function (head) {
      head.classList.remove('article-sidebar__toc-section-head--current');
    });
    listEl.querySelectorAll('.article-sidebar__toc-sublist-li--current').forEach(function (li) {
      li.classList.remove('article-sidebar__toc-sublist-li--current');
    });
    listEl.querySelectorAll('.article-sidebar__toc-section--has-active-child').forEach(function (section) {
      section.classList.remove('article-sidebar__toc-section--has-active-child');
    });

    var activeLink = null;
    listEl.querySelectorAll('a.article-sidebar__toc-link').forEach(function (a) {
      var tid = a.getAttribute('data-toc-target');
      var on = !!activeId && tid === activeId;
      a.classList.toggle('article-sidebar__toc-link--active', on);
      if (on) activeLink = a;
    });

    if (!activeLink) return;

    if (activeLink.classList.contains('article-sidebar__toc-link--parent')) {
      var head = activeLink.closest('.article-sidebar__toc-section-head');
      if (head) head.classList.add('article-sidebar__toc-section-head--current');
    }

    if (activeLink.classList.contains('article-sidebar__toc-link--child')) {
      var li = activeLink.closest('li');
      if (li && li.parentElement && li.parentElement.classList.contains('article-sidebar__toc-sublist')) {
        li.classList.add('article-sidebar__toc-sublist-li--current');
      }
      var section = activeLink.closest('.article-sidebar__toc-section');
      if (section) section.classList.add('article-sidebar__toc-section--has-active-child');
    }

    scrollActiveTocItemIntoView(listEl, activeLink);
  }

  function updateTocToggleLabel(tocBox, listEl, activeId) {
    var textEl = tocBox && tocBox.querySelector('[data-article-toc-toggle-text]');
    if (!textEl || !tocBox) return;
    var def = tocBox.getAttribute('data-toc-default-label') || textEl.textContent.trim() || '目录';
    if (!activeId) {
      textEl.textContent = def;
      return;
    }
    var link = findTocLinkByTargetId(listEl, activeId);
    if (link) {
      var t = (link.textContent || '').trim();
      if (t.length > 46) t = t.slice(0, 43) + '…';
      textEl.textContent = t;
    } else {
      textEl.textContent = def;
    }
  }

  function updateTocScrollSpy(root, listEl, tocBox) {
    var marker = scrollMarkerY();
    var nodes = root.querySelectorAll('h2[id], h3[id]');
    var activeId = null;
    nodes.forEach(function (el) {
      if (el.getBoundingClientRect().top <= marker) {
        activeId = el.id;
      }
    });
    setActiveTocLink(listEl, activeId);
    if (tocBox) updateTocToggleLabel(tocBox, listEl, activeId);
  }

  function syncTocDropdownMode(tocBox) {
    var toggle = tocBox.querySelector('[data-article-toc-toggle]');
    var panel = tocBox.querySelector('[data-article-toc-panel]');
    if (!toggle || !panel) return;
    var mobile = false;
    try {
      mobile = window.matchMedia('(max-width: 989px)').matches;
    } catch (e) {}
    if (!mobile) {
      tocBox.classList.remove('article-sidebar__toc--open');
      panel.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      panel.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', tocBox.classList.contains('article-sidebar__toc--open') ? 'true' : 'false');
    }
  }

  function initTocDropdown(tocBox, listEl) {
    var toggle = tocBox.querySelector('[data-article-toc-toggle]');
    var panel = tocBox.querySelector('[data-article-toc-panel]');
    if (!toggle || !panel) return;

    function onToggleClick(e) {
      try {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
      } catch (err) {
        return;
      }
      e.preventDefault();
      tocBox.classList.toggle('article-sidebar__toc--open');
      syncTocDropdownMode(tocBox);
    }

    toggle.addEventListener('click', onToggleClick);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!tocBox.classList.contains('article-sidebar__toc--open')) return;
      tocBox.classList.remove('article-sidebar__toc--open');
      syncTocDropdownMode(tocBox);
    });

    document.addEventListener(
      'click',
      function (e) {
        if (!tocBox.classList.contains('article-sidebar__toc--open')) return;
        if (tocBox.contains(e.target)) return;
        tocBox.classList.remove('article-sidebar__toc--open');
        syncTocDropdownMode(tocBox);
      },
      true
    );

    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var a = e.target.closest('a.article-sidebar__toc-link[href^="#"]');
        if (!a || !listEl.contains(a)) return;
        try {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
        } catch (err) {
          return;
        }
        tocBox.classList.remove('article-sidebar__toc--open');
        syncTocDropdownMode(tocBox);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncTocDropdownMode(tocBox);
      }, 150);
    });

    syncTocDropdownMode(tocBox);
  }

  function bindTocAccordion(listEl) {
    listEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.article-sidebar__toc-chevron');
      if (!btn || !listEl.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var section = btn.closest('.article-sidebar__toc-section');
      if (!section) return;
      var sub = section.querySelector('.article-sidebar__toc-sublist');
      if (!sub) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.hidden = expanded;
    });
  }

  function bindInArticleHashNavigation(layout, main, listEl, tocBox) {
    layout.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest('a.article-sidebar__toc-link[href^="#"]');
        if (!a || !layout.contains(a)) return;
        if (listEl && !listEl.contains(a)) return;
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;

        var frag = href.slice(1);
        var target = resolveHashTarget(frag);
        if (!target) return;

        if (!main.contains(target)) {
          return;
        }

        e.preventDefault();
        expandSectionForTarget(listEl, target);
        var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
        navigateArticleHash(main, frag, { behavior: behavior });
        requestAnimationFrame(function () {
          setActiveTocLink(listEl, target.id);
          if (tocBox) updateTocToggleLabel(tocBox, listEl, target.id);
        });
      },
      false
    );

    layout.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest('a[href^="#"]');
        if (!a || !layout.contains(a)) return;
        if (listEl && listEl.contains(a)) return;
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;

        var frag = href.slice(1);
        var target = resolveHashTarget(frag);
        if (!target) return;

        if (!main.contains(target)) {
          return;
        }

        e.preventDefault();
        var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
        navigateArticleHash(main, frag, { behavior: behavior });
        expandSectionForTarget(listEl, target);
        requestAnimationFrame(function () {
          setActiveTocLink(listEl, target.id);
          if (tocBox) updateTocToggleLabel(tocBox, listEl, target.id);
        });
      },
      false
    );
  }

  function initTocScrollSpy(root, listEl, tocBox) {
    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateTocScrollSpy(root, listEl, tocBox);
      });
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    onScrollOrResize();
  }

  function initToc(layout, main) {
    var root = layout.querySelector('[data-article-toc-root]');
    var listEl = layout.querySelector('[data-article-toc-list]');
    var tocBox = layout.querySelector('[data-article-toc-box]');
    if (!root || !listEl || !tocBox) return;

    var flow = root.querySelectorAll('h2, h3');
    var sections = [];
    var current = null;

    flow.forEach(function (node) {
      if (node.tagName === 'H2') {
        current = { h2: node, h3s: [] };
        sections.push(current);
      } else if (node.tagName === 'H3' && current) {
        current.h3s.push(node);
      }
    });

    listEl.innerHTML = '';

    if (!sections.length) {
      tocBox.hidden = true;
      return;
    }

    tocBox.hidden = false;
    var usedIds = {};
    var firstExpandableIndex = -1;

    sections.forEach(function (sec, si) {
      if (sec.h3s.length && firstExpandableIndex < 0) {
        firstExpandableIndex = si;
      }
    });

    sections.forEach(function (sec, si) {
      var h2Id = ensureHeadingId(sec.h2, usedIds, 'h2', si);
      sec.h3s.forEach(function (h3, hi) {
        ensureHeadingId(h3, usedIds, 'h3', si * 100 + hi);
      });

      var li = document.createElement('li');
      li.className = 'article-sidebar__toc-section';

      var head = document.createElement('div');
      head.className = 'article-sidebar__toc-section-head';

      var aParent = document.createElement('a');
      aParent.href = '#' + h2Id;
      aParent.className = 'article-sidebar__toc-link article-sidebar__toc-link--parent';
      aParent.setAttribute('data-toc-target', h2Id);
      aParent.textContent = sec.h2.textContent.trim();
      head.appendChild(aParent);

      if (sec.h3s.length) {
        var expanded = si === firstExpandableIndex;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'article-sidebar__toc-chevron';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.setAttribute('aria-label', '展开或折叠小节');
        head.appendChild(btn);

        var sub = document.createElement('ul');
        sub.className = 'article-sidebar__toc-sublist';
        sub.hidden = !expanded;

        sec.h3s.forEach(function (h3) {
          var hid = h3.id;
          var subLi = document.createElement('li');
          var aChild = document.createElement('a');
          aChild.href = '#' + hid;
          aChild.className = 'article-sidebar__toc-link article-sidebar__toc-link--child';
          aChild.setAttribute('data-toc-target', hid);
          aChild.textContent = h3.textContent.trim();
          subLi.appendChild(aChild);
          sub.appendChild(subLi);
        });

        li.appendChild(head);
        li.appendChild(sub);
      } else {
        li.appendChild(head);
      }

      listEl.appendChild(li);
    });

    bindTocAccordion(listEl);
    bindInArticleHashNavigation(layout, main, listEl, tocBox);
    initTocDropdown(tocBox, listEl);
    initTocScrollSpy(root, listEl, tocBox);
  }

  function initArticleSidebar(layout) {
    var main = layout.querySelector('.article-template__sidebar-main');
    if (!main) return;

    initToc(layout, main);

    function tryApplyInitialHash() {
      var h = window.location.hash;
      if (!h || h.length < 2) return;
      var frag = h.slice(1);
      var target = resolveHashTarget(frag);
      if (!target || !main.contains(target)) return;
      var listEl = layout.querySelector('[data-article-toc-list]');
      var tocBox = layout.querySelector('[data-article-toc-box]');
      expandSectionForTarget(listEl, target);
      navigateArticleHash(main, frag, { behavior: 'auto' });
      requestAnimationFrame(function () {
        setActiveTocLink(listEl, target.id);
        if (tocBox) updateTocToggleLabel(tocBox, listEl, target.id);
      });
    }

    window.addEventListener('hashchange', function () {
      var h2 = window.location.hash;
      if (!h2 || h2.length < 2) return;
      var frag = h2.slice(1);
      var target = resolveHashTarget(frag);
      var listEl = layout.querySelector('[data-article-toc-list]');
      var tocBox = layout.querySelector('[data-article-toc-box]');
      if (target && main.contains(target)) {
        expandSectionForTarget(listEl, target);
      }
      navigateArticleHash(main, frag, { behavior: 'auto' });
      if (target && target.id) {
        requestAnimationFrame(function () {
          setActiveTocLink(listEl, target.id);
          if (tocBox) updateTocToggleLabel(tocBox, listEl, target.id);
        });
      }
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(tryApplyInitialHash);
    });
  }

  document.querySelectorAll('[data-article-sidebar-layout]').forEach(function (layout) {
    initArticleSidebar(layout);
  });
})();
